{
  "familyId": "REK-CIJF-MIN",
  "questions": [
    {
      "id": "REK-CIJF-MIN-001",
      "familyId": "REK-CIJF-MIN",
      "module": "Basisrekenen",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_aftrekken",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 742 − 368",
      "options": [],
      "correctAnswer": "374",
      "data": {
        "operand1": 742,
        "operand2": 368,
        "operation": "-"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend aftrekken — lenen",
            "content": "Begin rechts. Eenheden: 2 − 8 kan niet → leen 1 tiental (= 10). Nu: 12 − 8 = 4. Tientallen: 3 (was 4, min 1 geleend) − 6 kan niet → leen 1 honderdtal. Nu: 13 − 6 = 7. Honderdtallen: 6 (was 7, min 1 geleend) − 3 = 3. Antwoord: 374.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_aftrekken_lenen_basis",
      "variantIndex": 1,
      "pedagogy": { "dok": 1 },
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "742 − 368: Begin rechts. Eenheden: 2 − 8 kan niet → leen 10 van de tientallen: 12 − 8 = 4. Tientallen: 3 (was 4, min 1 geleend) − 6 kan niet → leen 10 van de honderdtallen: 13 − 6 = 7. Honderdtallen: 6 (was 7, min 1 geleend) − 3 = 3. Antwoord: 374.",
        "solutionSteps": [
          "Eenheden: 2 − 8 kan niet → leen: 12 − 8 = 4",
          "Tientallen: (4−1) − 6 = 3 − 6 kan niet → leen: 13 − 6 = 7",
          "Honderdtallen: (7−1) − 3 = 6 − 3 = 3",
          "Antwoord: 374"
        ]
      }
    },
    {
      "id": "REK-CIJF-MIN-002",
      "familyId": "REK-CIJF-MIN",
      "module": "Basisrekenen",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_aftrekken",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 503 − 247",
      "options": [],
      "correctAnswer": "256",
      "data": {
        "operand1": 503,
        "operand2": 247,
        "operation": "-"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lenen bij een 0",
            "content": "Lastig: bij de tientallen staat een 0! Eenheden: 3 − 7 kan niet → leen van tientallen. Maar de tientallen zijn 0! Leen dan eerst van de honderdtallen: 5 wordt 4, de 0 wordt 10. Nu leen je van de tientallen: 10 wordt 9, de 3 wordt 13. 13 − 7 = 6. Tientallen: 9 − 4 = 5. Honderdtallen: 4 − 2 = 2. Antwoord: 256.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_aftrekken_lenen_nul",
      "variantIndex": 2,
      "pedagogy": { "dok": 2 },
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "503 − 247 is lastig omdat er een 0 bij de tientallen staat. Eenheden: 3 − 7 kan niet. Je wilt lenen van de tientallen, maar die zijn 0. Leen dan eerst van de honderdtallen: 5→4, 0→10. Nu leen je van de tientallen: 10→9, 3→13. Eenheden: 13 − 7 = 6. Tientallen: 9 − 4 = 5. Honderdtallen: 4 − 2 = 2. Antwoord: 256.",
        "solutionSteps": [
          "Eenheden: 3 − 7 kan niet, tientallen = 0 → leen van honderdtallen",
          "Honderdtallen: 5 → 4, tientallen: 0 → 10",
          "Nu leen van tientallen: 10 → 9, eenheden: 3 → 13",
          "Eenheden: 13 − 7 = 6",
          "Tientallen: 9 − 4 = 5",
          "Honderdtallen: 4 − 2 = 2",
          "Antwoord: 256"
        ]
      }
    },
    {
      "id": "REK-CIJF-MIN-003",
      "familyId": "REK-CIJF-MIN",
      "module": "Basisrekenen",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_aftrekken",
      "questionType": "fill_in",
      "question": "Een winkel heeft 1.250 flessen water. Er worden 487 flessen verkocht. Hoeveel flessen zijn er nog over?",
      "options": [],
      "correctAnswer": "763",
      "data": {
        "acceptedAnswers": ["763"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "column",
          "showWhen": "wrong",
          "data": {
            "operand1": 1250,
            "operand2": 487,
            "operation": "-"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aftrekken met context",
            "content": "Je moet aftrekken: 1.250 − 487. Begin rechts:\n• E: 0 − 7 kan niet → leen: 10 − 7 = 3\n• T: 4 (was 5, min 1) − 8 kan niet → leen: 14 − 8 = 6\n• H: 1 (was 2, min 1) − 4 kan niet → leen: 11 − 4 = 7\n• D: 0 (was 1, min 1) = 0\nAntwoord: 763",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_aftrekken_context",
      "variantIndex": 3,
      "pedagogy": { "dok": 2 },
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "1.250 − 487: Eenheden: 0 − 7 kan niet → leen: 10 − 7 = 3. Tientallen: 4 (was 5, min 1 geleend) − 8 kan niet → leen: 14 − 8 = 6. Honderdtallen: 1 (was 2, min 1 geleend) − 4 kan niet → leen: 11 − 4 = 7. Duizendtallen: 0 (was 1, min 1 geleend). Antwoord: 763 flessen.",
        "solutionSteps": [
          "Herken de bewerking: 1.250 − 487",
          "Eenheden: 0 − 7 → leen: 10 − 7 = 3",
          "Tientallen: 4 − 8 → leen: 14 − 8 = 6",
          "Honderdtallen: 1 − 4 → leen: 11 − 4 = 7",
          "Antwoord: 763 flessen"
        ]
      }
    },
    {
      "id": "REK-CIJF-MIN-004",
      "familyId": "REK-CIJF-MIN",
      "module": "Basisrekenen",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_aftrekken",
      "questionType": "multiple_choice",
      "question": "Bij cijferend aftrekken van 835 − 479: wat doe je als eerste bij de eenheden?",
      "options": [
        "5 − 9 kan niet, dus je leent 1 tiental en rekent 15 − 9 = 6",
        "9 − 5 = 4",
        "5 − 9 = −4, dus je schrijft −4 op",
        "Je slaat de eenheden over en begint bij de tientallen"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lenen bij aftrekken",
            "content": "Als het bovenste cijfer kleiner is dan het onderste, kun je niet aftrekken. Dan leen je 1 van de volgende kolom (= 10 erbij). 5 wordt 15, en het tiental wordt 1 minder. 15 − 9 = 6.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_aftrekken_lenen_begrip",
      "variantIndex": 4,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.subtract-reversed", "optionIndex": 1, "label": "Draait de getallen om: trekt bovenste van onderste af" },
          { "id": "rek.negative-written", "optionIndex": 2, "label": "Schrijft negatief getal op i.p.v. te lenen" },
          { "id": "rek.column-skipped", "optionIndex": 3, "label": "Slaat kolommen over bij het aftrekken" }
        ]
      },
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "Bij de eenheden: 5 − 9 kan niet (5 is kleiner dan 9). Je leent 1 tiental van de tientallen. Dat is 10 eenheden erbij: 5 + 10 = 15. Nu reken je: 15 − 9 = 6. Het volledige antwoord: 835 − 479 = 356.",
        "solutionSteps": [
          "Eenheden: 5 − 9 kan niet → leen 1 tiental",
          "5 + 10 = 15, reken: 15 − 9 = 6",
          "Tientallen: 2 (was 3, min 1) − 7 kan niet → leen: 12 − 7 = 5",
          "Honderdtallen: 7 (was 8, min 1) − 4 = 3",
          "Antwoord: 356"
        ],
        "distractorExplanations": {
          "0": "Goed! 5 − 9 kan niet, dus je leent 10 van de tientallen. 15 − 9 = 6.",
          "1": "Je draaide de getallen om: 9 − 5 in plaats van 5 − 9. Bij aftrekken trek je altijd het onderste getal af van het bovenste. Het bovenste getal is 5, het onderste is 9.",
          "2": "Bij cijferend aftrekken werk je niet met negatieve getallen. Als het bovenste cijfer kleiner is, leen je van de volgende kolom. Onthoud: lenen, niet min-getallen schrijven.",
          "3": "Je begint altijd rechts bij de eenheden, niet bij de tientallen. De volgorde is: eenheden → tientallen → honderdtallen. Sla geen kolom over."
        }
      }
    },
    {
      "id": "REK-CIJF-MIN-005",
      "familyId": "REK-CIJF-MIN",
      "module": "Basisrekenen",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_aftrekken",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 1.000 − 463",
      "options": [],
      "correctAnswer": "537",
      "data": {
        "operand1": 1000,
        "operand2": 463,
        "operation": "-"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aftrekken van een rond getal",
            "content": "1.000 − 463: alle bovenste cijfers zijn 0 (behalve de 1). Je moet meerdere keren lenen. Truc: 1.000 − 463 = 999 − 463 + 1 = 536 + 1 = 537. Of: leen stap voor stap door alle kolommen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_aftrekken_rond_getal",
      "variantIndex": 5,
      "pedagogy": { "dok": 2 },
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "1.000 − 463 is lastig omdat er drie nullen staan. Truc: 1.000 = 999 + 1. Dus: 999 − 463 = 536, plus 1 = 537. Of leen stap voor stap: 0−3 kan niet → leen van tientallen (ook 0) → leen van honderdtallen (ook 0) → leen van duizendtallen. Antwoord: 537.",
        "solutionSteps": [
          "Truc: 1.000 = 999 + 1",
          "999 − 463: E: 9 − 3 = 6, T: 9 − 6 = 3, H: 9 − 4 = 5",
          "999 − 463 = 536",
          "536 + 1 = 537",
          "Antwoord: 537"
        ]
      }
    },
    {
      "id": "REK-CIJF-MIN-006",
      "familyId": "REK-CIJF-MIN",
      "module": "Basisrekenen",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_aftrekken",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 5.312 − 2.847",
      "options": [],
      "correctAnswer": "2465",
      "data": {
        "operand1": 5312,
        "operand2": 2847,
        "operation": "-"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cijferend aftrekken — 4 cijfers",
            "content": "Zet onder elkaar en begin rechts:\n• E: 2 − 7 kan niet → leen: 12 − 7 = 5\n• T: 0 (was 1, min 1) − 4 kan niet → leen: 10 − 4 = 6\n• H: 2 (was 3, min 1) − 8 kan niet → leen: 12 − 8 = 4\n• D: 4 (was 5, min 1) − 2 = 2\nAntwoord: 2.465",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_aftrekken_viercijferig_meervoudig_lenen",
      "variantIndex": 6,
      "pedagogy": { "dok": 2 },
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "5.312 − 2.847: Begin rechts. Eenheden: 2 − 7 kan niet → leen: 12 − 7 = 5. Tientallen: 0 (was 1, min 1 geleend) − 4 kan niet → leen: 10 − 4 = 6. Honderdtallen: 2 (was 3, min 1 geleend) − 8 kan niet → leen: 12 − 8 = 4. Duizendtallen: 4 (was 5, min 1 geleend) − 2 = 2. Antwoord: 2.465.",
        "solutionSteps": [
          "Eenheden: 2 − 7 kan niet → leen: 12 − 7 = 5",
          "Tientallen: 0 − 4 kan niet → leen: 10 − 4 = 6",
          "Honderdtallen: 2 − 8 kan niet → leen: 12 − 8 = 4",
          "Duizendtallen: 4 − 2 = 2",
          "Antwoord: 2.465"
        ]
      }
    },
    {
      "id": "REK-CIJF-MIN-007",
      "familyId": "REK-CIJF-MIN",
      "module": "Basisrekenen",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_aftrekken",
      "questionType": "cijferend_rekenen",
      "question": "Reken cijferend uit: 3.000 − 1.274",
      "options": [],
      "correctAnswer": "1726",
      "data": {
        "operand1": 3000,
        "operand2": 1274,
        "operation": "-"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aftrekken van een rond duizendtal",
            "content": "3.000 − 1.274: alle bovenste cijfers zijn 0 (behalve de 3). Truc: 3.000 = 2.999 + 1. Dus: 2.999 − 1.274 = 1.725, plus 1 = 1.726. Of leen stap voor stap door alle kolommen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_aftrekken_rond_duizendtal",
      "variantIndex": 7,
      "pedagogy": { "dok": 2 },
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "3.000 − 1.274 is lastig omdat er drie nullen staan. Truc: 3.000 = 2.999 + 1. Dus: 2.999 − 1.274: E: 9 − 4 = 5, T: 9 − 7 = 2, H: 9 − 2 = 7, D: 2 − 1 = 1. Dat is 1.725, plus 1 = 1.726.",
        "solutionSteps": [
          "Truc: 3.000 = 2.999 + 1",
          "2.999 − 1.274: E: 9 − 4 = 5, T: 9 − 7 = 2, H: 9 − 2 = 7, D: 2 − 1 = 1",
          "2.999 − 1.274 = 1.725",
          "1.725 + 1 = 1.726",
          "Antwoord: 1.726"
        ]
      }
    },
    {
      "id": "REK-CIJF-MIN-008",
      "familyId": "REK-CIJF-MIN",
      "module": "Basisrekenen",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "cijferend",
      "subSkill": "cijferend_aftrekken",
      "questionType": "fill_in",
      "question": "Een zwembad heeft 4.200 liter water. Er lekt 1.635 liter weg. Hoeveel liter water is er nog?",
      "options": [],
      "correctAnswer": "2565",
      "data": {
        "acceptedAnswers": ["2565", "2.565"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "column",
          "showWhen": "wrong",
          "data": {
            "operand1": 4200,
            "operand2": 1635,
            "operation": "-"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aftrekken met context — 4 cijfers",
            "content": "Je moet aftrekken: 4.200 − 1.635. Begin rechts:\n• E: 0 − 5 kan niet → leen: 10 − 5 = 5\n• T: 9 (was 0, geleend van H) − 3 = 6. Maar wacht: 0 − 3 kan niet, dus leen van H.\n• Gebruik de truc: 4.200 = 4.199 + 1. Dan: 4.199 − 1.635 = 2.564, plus 1 = 2.565.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cijferend_aftrekken_context_viercijferig",
      "variantIndex": 8,
      "pedagogy": { "dok": 2 },
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "4.200 − 1.635: Truc: 4.200 = 4.199 + 1. Reken: 4.199 − 1.635: E: 9 − 5 = 4, T: 9 − 3 = 6, H: 1 − 6 kan niet → leen: 11 − 6 = 5, D: 3 (was 4, min 1) − 1 = 2. Dat is 2.564, plus 1 = 2.565 liter.",
        "solutionSteps": [
          "Herken de bewerking: 4.200 − 1.635",
          "Truc: 4.200 = 4.199 + 1",
          "4.199 − 1.635: E: 9−5=4, T: 9−3=6, H: 1−6→leen: 11−6=5, D: 3−1=2",
          "4.199 − 1.635 = 2.564",
          "2.564 + 1 = 2.565",
          "Antwoord: 2.565 liter"
        ]
      }
    }
  ]
}